import Nav from "./nav"
import Search from "./search"
import Form from "./form"
import Header from "./header"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Search(jQuery)
    Form(jQuery)
    Header(jQuery)
})
